import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { StackView, Text } from 'localmed-core';
import React from 'react';
import type { Theme } from '../../../../../../../diTheme';
import type { ILMProvider, ThemeProps } from '../../../../../../../types';

interface IProps extends ILMProvider {
  selected: boolean;
}

const Image = styled('img')(
  ({ theme }: ThemeProps) => css`
    height: 60px;
    width: 60px;
    border-radius: 50%;
    padding: ${theme.space.xs};
  `
);

interface RadioGroupItemWrapperProps {
  selected?: boolean;
}

const Wrapper = styled(StackView)<RadioGroupItemWrapperProps, Theme>(
  ({ theme, selected }) => css`
    border-radius: ${theme.radii.lg};
    border: 1px solid ${theme.colors.lightGray};
    padding: ${theme.space.xs};
    margin-right: ${theme.space.sm};
    background-color: ${selected ? theme.colors.blue : 'transparent'};
    color: ${selected ? theme.colors.white : theme.colors.black};
    transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out,
      color 200ms ease-in-out;
    margin: ${theme.space.xs};
  `
);

export default function SchedulingProviderCard({ profile, display, selected }: IProps) {
  const {
    specialties: { nodes: specialties },
  } = profile;
  return (
    <Wrapper spacing="xs" direction="row" selected={selected}>
      <Image alt="provider image" src={profile.photo} />
      <StackView spacing="none">
        <Text fontWeight="bold">{display}</Text>
        <Text fontSize="sm">{specialties.map((s) => s.specialistName).join(', ')}</Text>
      </StackView>
    </Wrapper>
  );
}
